import { Suspense, useEffect } from "react";
import initializeApp from "./app/init";
import useZoneId from "./hooks/useZoneId";
import { useTernaryDarkMode } from "usehooks-ts";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import BandwagonRoutes from "./BandwagonRoutes";
import { AuthContextProvider } from "./hooks/useAuth";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import SuspenseContent from "./containers/SuspenseContent";

// Initializing different libraries
initializeApp();

function App() {
  // Check for login and initialize axios
  const { isDarkMode } = useTernaryDarkMode();
  useEffect(() => {
    // 👆 daisy UI themes initialization
    document
      .querySelector("html")
      ?.setAttribute("data-theme", isDarkMode ? "dark" : "light");
  }, [isDarkMode]);

  const zoneId = useZoneId();
  const client = new QueryClient();

  if (!zoneId) {
    return null;
  }

  const router = createBrowserRouter(BandwagonRoutes({ zoneId }));
  return (
    <AuthContextProvider>
      <QueryClientProvider client={client}>
        <RouterProvider router={router} />
        <Suspense fallback={<SuspenseContent />} />
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </AuthContextProvider>
  );
}

export default App;
